import React, { useEffect, useState } from "react";
import HistoryClasses from "./index.module.css";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { Error, Error_Dark, Success_Dark } from "Util/Toast";
import Moment from "react-moment";
import { useNavigate, useParams } from "react-router-dom";
import { FaFilePdf, FaCopy, FaCode } from "react-icons/fa";
import Modal from "react-modal";

const POLICY_LABELS = {
    Privacy_Policy: "Privacy Policy",
    Terms_and_Conditions: "Terms and Conditions",
    Refund_Policy: "Refund Policy",
};

const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
        Success_Dark("Copied");
    });
};

function PolicyHistory() {
    const { PolicyType } = useParams();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [viewItem, setViewItem] = useState(null);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const Navigate = useNavigate();

    const getHistory = () => {
        setLoading(true);
        Services.getPolicyHistory("GET", null, token, PolicyType)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.History || []);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                Error_Dark("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getHistory();
        // eslint-disable-next-line
    }, [PolicyType]);

    const backButton = () => {
        Navigate(-1);
    };

    const closeModal = () => {
        setViewItem(null);
    };

    return (
        <Layout Active={"Policy"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>
                    {POLICY_LABELS[PolicyType] || PolicyType} History
                </title>
            </Helmet>
            <div className={HistoryClasses["Container"]}>
                <button
                    onClick={backButton}
                    className={HistoryClasses["back"]}>
                    Back
                </button>
                <div className={HistoryClasses["Tutor"]}>
                    <h3>
                        {POLICY_LABELS[PolicyType] || PolicyType} History
                    </h3>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "Version",
                                "Edited By",
                                "Edited At",
                                "Hash",
                                "PDF",
                                "Actions",
                            ]}
                        />
                    ) : data.length > 0 ? (
                        <div className={HistoryClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Version</th>
                                        <th>Edited By</th>
                                        <th>Edited At</th>
                                        <th>Hash</th>
                                        <th>PDF</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => (
                                        <tr
                                            key={
                                                item.PolicyPageHistoryID
                                            }>
                                            <td>{item.Version || "-"}</td>
                                            <td>
                                                {[
                                                    item.EditedByFirstName,
                                                    item.EditedByLastName,
                                                ]
                                                    .filter(Boolean)
                                                    .join(" ") || "-"}
                                            </td>
                                            <td>
                                                {item.EditedAt ? (
                                                    <Moment format="DD-MM-YYYY hh:mm A">
                                                        {new Date(
                                                            item.EditedAt
                                                        )}
                                                    </Moment>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td>
                                                {item.ContentHash ? (
                                                    <div
                                                        className={
                                                            HistoryClasses[
                                                                "hashCell"
                                                            ]
                                                        }>
                                                        <span
                                                            className={
                                                                HistoryClasses[
                                                                    "hash"
                                                                ]
                                                            }
                                                            title={
                                                                item.ContentHash
                                                            }>
                                                            {`${item.ContentHash.slice(
                                                                0,
                                                                10
                                                            )}...`}
                                                        </span>
                                                        <button
                                                            className={
                                                                HistoryClasses[
                                                                    "iconBtn"
                                                                ]
                                                            }
                                                            title="Copy Hash"
                                                            onClick={() =>
                                                                copyToClipboard(
                                                                    item.ContentHash
                                                                )
                                                            }>
                                                            <FaCopy />
                                                        </button>
                                                    </div>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td>
                                                {item.SnapshotPDFPath ? (
                                                    <a
                                                        className={
                                                            HistoryClasses[
                                                                "iconBtn"
                                                            ]
                                                        }
                                                        href={
                                                            item.SnapshotPDFPath
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        title="View PDF Snapshot">
                                                        <FaFilePdf />
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td>
                                                <button
                                                    className={
                                                        HistoryClasses[
                                                            "iconBtn"
                                                        ]
                                                    }
                                                    title="View Raw HTML"
                                                    onClick={() =>
                                                        setViewItem(item)
                                                    }>
                                                    <FaCode /> View Raw
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No History Found</p>
                        </div>
                    )}
                </div>
            </div>

            <Modal
                isOpen={!!viewItem}
                onRequestClose={closeModal}
                contentLabel="Raw HTML"
                className={HistoryClasses["modal"]}
                overlayClassName={HistoryClasses["overlay"]}>
                <div className={HistoryClasses["modalHeader"]}>
                    <h3>
                        Raw HTML
                        {viewItem?.Version ? ` — ${viewItem.Version}` : ""}
                    </h3>
                    <div className={HistoryClasses["modalHeaderBtns"]}>
                        <button
                            className={HistoryClasses["button"]}
                            onClick={() =>
                                copyToClipboard(viewItem?.RawHTML || "")
                            }>
                            <FaCopy /> Copy HTML
                        </button>
                        <button
                            className={HistoryClasses["button"]}
                            onClick={closeModal}>
                            Close
                        </button>
                    </div>
                </div>
                <pre className={HistoryClasses["rawHtml"]}>
                    {viewItem?.RawHTML || "No content available"}
                </pre>
            </Modal>
        </Layout>
    );
}

export default PolicyHistory;
